import { render, staticRenderFns } from "./matchList.vue?vue&type=template&id=0bf4836c&"
import script from "./matchList.vue?vue&type=script&lang=ts&"
export * from "./matchList.vue?vue&type=script&lang=ts&"
import style0 from "./matchList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports